var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"bi ml-2 icon-grow bi-share tl-copy-page-permalink-icon",attrs:{"data-toggle":"tooltip","data-html":"true","data-placement":"bottom","title":"copy permalink to current page","data-clipboard-text":_vm.windowUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }